import { useState } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Scanner from "./components/Scanner";
import InstructionCard from "./components/Instructions";


function App() {

  const [start, setStart] = useState(false)
  const [action, setAction] = useState("Start")

  const handleStart = () => {
    setStart(prev => {
      if (!prev) {
        setAction("Stop")
      }
      else {
        setAction("Start")
      }
      return !prev
    })


  }
  return (
    <div >
      <Header onStart={handleStart} action={action} />
      <div style={{ height: "30vh" }}>
        {
          start ?
            <Scanner />
            :
            <InstructionCard />
        }
      </div>
    </div>
  );
}

export default App;
